import script from "./TargetMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./TargetMap.vue?vue&type=script&lang=ts&setup=true"

import "./TargetMap.vue?vue&type=style&index=0&id=32b73dad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b73dad"]])

export default __exports__